import { type ComponentProps } from 'react';

import { Menu, type MenuRootProps } from '@ark-ui/react';

import {
	MenuCheckboxItem,
	MenuContent,
	MenuGroup,
	MenuItem,
	MenuLabel,
	MenuRadioGroup,
	MenuRadioItem,
	MenuSeparator,
	MenuSubContent,
	MenuSubRoot,
	MenuSubTrigger
} from '../menu/menu-parts';

type DropdownMenuRootProps = MenuRootProps;

function DropdownMenuRoot({
	lazyMount = true,
	unmountOnExit = true,
	...props
}: DropdownMenuRootProps) {
	return <Menu.Root lazyMount={lazyMount} unmountOnExit={unmountOnExit} {...props} />;
}

function DropdownMenuTrigger({ className, ...props }: ComponentProps<typeof Menu.Trigger>) {
	return <Menu.Trigger className={className} {...props} />;
}

const DropdownMenu = Object.assign(DropdownMenuRoot, {
	Root: DropdownMenuRoot,
	Trigger: DropdownMenuTrigger,
	Content: MenuContent,
	Item: MenuItem,
	CheckboxItem: MenuCheckboxItem,
	RadioGroup: MenuRadioGroup,
	RadioItem: MenuRadioItem,
	Group: MenuGroup,
	Label: MenuLabel,
	Separator: MenuSeparator,
	Sub: MenuSubRoot,
	SubTrigger: MenuSubTrigger,
	SubContent: MenuSubContent
});

export { DropdownMenu, type DropdownMenuRootProps };
